"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var services_1 = require("./services");
function createStore(defaultValue) {
    var storeState = defaultValue;
    var storeListeningComponents = [];
    function updateStoreState(newStoreState) {
        var oldStoreState = storeState;
        storeState = newStoreState;
        storeListeningComponents.forEach(function (_a) {
            var update = _a.update, options = _a.options;
            var shouldUpdate = !options ||
                !options.shouldUpdate ||
                !options.shouldUpdate(oldStoreState, newStoreState);
            if (!shouldUpdate) {
                return;
            }
            update();
        });
    }
    function useStoreState(options) {
        var forceUpdate = services_1.useForceUpdate();
        react_1.useLayoutEffect(function () {
            var listeningData = {
                options: options,
                update: forceUpdate,
            };
            storeListeningComponents.push(listeningData);
            return function () {
                services_1.removeArrayElement(storeListeningComponents, listeningData);
            };
        });
        return [storeState, updateStoreState];
    }
    return [useStoreState, updateStoreState];
}
exports.createStore = createStore;
